import { useEffect } from "react";
import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { useCanvasId } from "@/utils/utils";
import { useSession } from "@clerk/clerk-react";
import axios from "axios";

export const useTailwindClasses = () => {
  const canvasId = useCanvasId();
  const { session } = useSession();
  const { setTailwindClasses } = useCodebaseStore();

  useEffect(() => {
    const fetchTailwindClasses = async () => {
      if (!session || !canvasId) return;

      try {
        const supabaseJWT = await session.getToken();
        const response = await axios.get(
          `${
            import.meta.env.VITE_BACKEND_BASE_URL
          }/canvases/${canvasId}/tailwind/classes`,
          {
            headers: {
              Authorization: `Bearer ${supabaseJWT}`,
            },
          }
        );

        setTailwindClasses(response.data);
      } catch (error) {
        console.error("Error fetching Tailwind classes:", error);
        setTailwindClasses([]);
      }
    };

    fetchTailwindClasses();
  }, [canvasId, setTailwindClasses]);
};
